import { Tooltip } from '@crazyegginc/hatch';
import { ReactComponent as InfoIcon } from '@crazyegginc/hatch/dist/images/icon-info-circle-outline.svg';

import { inflect } from '/src/utils/string';
import { Dot } from './Dot';
import { CSAT_TOOLTIP } from './csat';

export function MetaRow({ totalViews, responseCount = undefined, optional, showAnswerRate, csatScore }) {
  const answerRate = totalViews > 0 ? Math.round((responseCount / totalViews) * 100) : 0;

  return (
    <div className="text-body-5 question-meta flex items-center space-x-2.5" data-testid="metarow">
      {responseCount != undefined && (
        <>
          <div>
            <span>
              {responseCount} {inflect('Response', responseCount)}
            </span>{' '}
          </div>
          <Dot />
        </>
      )}
      <span>{optional ? 'Not Required' : 'Required'}</span>

      {showAnswerRate ? (
        <>
          <Dot /> <span>{answerRate}% answer rate</span>
        </>
      ) : null}

      {csatScore !== null && csatScore !== undefined ? (
        <>
          <Dot />
          <span>CSAT: {csatScore}%</span>
          <Tooltip
            placement="top"
            tooltipContent={<div className="max-w-xs px-2 py-2.5 text-left">{CSAT_TOOLTIP}</div>}
          >
            <InfoIcon className="h-3.5 w-3.5 cursor-default fill-current text-cadet-blue-500" />
          </Tooltip>
        </>
      ) : null}
    </div>
  );
}
